export default __webpack_public_path__ + "static/si-summit-sansalvatore-code-1f5a17e4e8c4fd8b1c89410cd1c75dd6.jpg";